/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Diff_Pit1_DInputs */

const en_diff_pit1_d = /** @type {(inputs: Diff_Pit1_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Because arrays are matched by index, moving one element reports a change at every position it shifted. A three item list with the head moved to the tail produces three change entries even though the set of items is identical. Sort both sides by a stable field first if you want to compare membership rather than order.`)
};

const ko_diff_pit1_d = /** @type {(inputs: Diff_Pit1_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`배열이 인덱스로 대응되므로, 한 요소를 옮기면 밀려난 모든 위치에서 변경이 보고됩니다. 세 항목 목록에서 맨 앞을 맨 뒤로 옮기면 항목 집합은 동일한데도 세 개의 변경 항목이 나옵니다. 순서가 아니라 구성원을 비교하고 싶다면 안정적인 필드로 양쪽을 먼저 정렬하세요.`)
};

const ja_diff_pit1_d = /** @type {(inputs: Diff_Pit1_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`配列が添字で対応されるため、1 要素を動かすとずれたすべての位置で変更が報告されます。3 項目のリストで先頭を末尾に移すと、項目の集合は同じでも 3 件の変更項目が出ます。順序ではなく構成員を比べたいなら、安定したフィールドで両側を先に並べ替えてください。`)
};

/**
* | output |
* | --- |
* | "Because arrays are matched by index, moving one element reports a change at every position it shifted. A three item list with the head moved to the tail prod..." |
*
* @param {Diff_Pit1_DInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const diff_pit1_d = /** @type {((inputs?: Diff_Pit1_DInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Diff_Pit1_DInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_diff_pit1_d(inputs)
	if (locale === "ko") return ko_diff_pit1_d(inputs)
	return ja_diff_pit1_d(inputs)
});